/* @flow */

//----------------------------------------------------------------------//
//                         Imported NPM modules                         //
//----------------------------------------------------------------------//

import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
//                     Imported app modules/assets                      //
//----------------------------------------------------------------------//

import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import styles from './ElectroResponseMessage.module.scss';

//----------------------------------------------------------------------//
//                       Exported React component                       //
//----------------------------------------------------------------------//

type TypeProps = {
  // eslint-disable-line flow-prefer-exact-object-types
  responseMessage: string | ((t: translate) => string),
  showResponseMessage: boolean,
  isLoading: boolean,
  hasSuccess: boolean,
  hasError: boolean,
  showBackDrop: boolean,
};

@translate()
@observer
export default class ElectroResponseMessage extends React.Component<*> {
  render(): React.Element<*> {
    const {
      localState: {
        responseMessage,
        showResponseMessage,
        isLoading,
        hasSuccess,
        hasError,
        showBackDrop = true,
      },
      t,
      tReady,
      ...other
    }: TypeProps = this.props;

    const message = typeof responseMessage === 'function' ? responseMessage(t) : responseMessage;

    const action = (
      <Button
        variant="flat"
        className={styles.action}
        onClick={() => {
          this.props.localState.showResponseMessage = false;
        }}
      >
        {t('general:actions.ok')}
      </Button>
    );

    return (
      <React.Fragment>
        {(isLoading || hasSuccess) && showBackDrop && (
          <Backdrop className={styles['electro-response-backdrop']} open={showResponseMessage} />
        )}
        <Snackbar
          className={styles['electro-response-message']}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={showResponseMessage}
          ContentProps={{
            'aria-describedby': 'message-id',
            className: styles['snackbar-content'],
          }}
          action={hasError ? action : null}
          message={
            <React.Fragment>
              <span className={styles.text} id="message-id">
                {message}
              </span>
              {isLoading && <CircularProgress className={styles.loading} />}
              {hasSuccess && !isLoading && (
                <svg className={styles['icon-success']}>
                  <use xlinkHref="#icon-approve" />
                </svg>
              )}
            </React.Fragment>
          }
          {...other}
        />
      </React.Fragment>
    );
  }
}
